type PanelPreferenceKey = 'general' | 'meeting';
type PanelPreferenceValue = 'open' | 'closed';
export type PanelModeValue = 'sidepanel' | 'fullscreen';

const STORAGE_PREFIX = 'bizy-panel-pref-';
const MODE_KEY = 'bizy-panel-mode';

export function getBizyPanelPreference(key: PanelPreferenceKey): PanelPreferenceValue {
	try {
		const value = localStorage.getItem(`${STORAGE_PREFIX}${key}`);
		return value === 'closed' ? 'closed' : 'open';
	} catch {
		return 'open';
	}
}

export function setBizyPanelPreference(key: PanelPreferenceKey, value: PanelPreferenceValue): void {
	try {
		localStorage.setItem(`${STORAGE_PREFIX}${key}`, value);
	} catch {
		// localStorage unavailable
	}
}

export function getBizyPanelMode(): PanelModeValue {
	try {
		const value = localStorage.getItem(MODE_KEY);
		return value === 'fullscreen' ? 'fullscreen' : 'sidepanel';
	} catch {
		return 'sidepanel';
	}
}

export function setBizyPanelMode(value: PanelModeValue): void {
	try {
		localStorage.setItem(MODE_KEY, value);
	} catch {
		// localStorage unavailable
	}
}
